export default __webpack_public_path__ + "static/media/waiting-screen.c6af4a44.png";